export default __webpack_public_path__ + "./fonts/redoTest.78b87cf5.svg";